import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";

export const DEFAULT_UN_CHECK_COLOR = colorsPalettes.carbon[200];
export const INITIAL_SELECTION = 3;
export const MAX_SELECTION = 10;
export const getTotalKeywordsName = () => translate("common.total");
export const TOTAL_KEYWORDS_ID = "total" as const;
